import { createBaseApi } from "../baseApi";
import { LoginModel } from "model/auth/login.schema";

// Create auth API with base configuration
export const authApi = createBaseApi("auth", "/auth").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Auth
    login: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
      transformResponse: (response) => LoginModel.jsonToModel(response),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/logout",
        method: "POST",
      }),
    }),
    refreshToken: builder.mutation({
      query: () => ({
        url: "/refresh-token",
        method: "POST",
      }),
    }),
    // Confirm OTP
    sendConfirmOtp: builder.mutation({
      query: (payload) => ({
        url: "otp/confirm/send",
        method: "POST",
        body: payload,
      }),
    }),
    verifyConfirmOtp: builder.mutation({
      query: (payload) => ({
        url: "otp/confirm/verify",
        method: "POST",
        body: payload,
      }),
    }),
    // Password Reset OTP
    sendPasswordResetOtp: builder.mutation({
      query: (payload) => ({
        url: "/otp/reset/send",
        method: "POST",
        body: payload,
      }),
    }),
    verifyPasswordResetOtp: builder.mutation({
      query: (payload) => ({
        url: "/otp/reset/verify",
        method: "POST",
        body: payload,
      }),
    }),
    resetPassword: builder.mutation({
      query: (payload) => ({
        url: "/reset",
        method: "POST",
        body: payload,
      }),
    }),
    // Check Email
    checkEmail: builder.mutation({
      query: (payload) => ({
        url: "/check-email",
        method: "POST",
        body: payload,
      }),
    }),
    change: builder.mutation({
      query: (payload) => ({
        url: "/change",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  //
  useLoginMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useSendConfirmOtpMutation,
  useVerifyConfirmOtpMutation,
  useSendPasswordResetOtpMutation,
  useVerifyPasswordResetOtpMutation,
  useResetPasswordMutation,
  useCheckEmailMutation,
  useChangeMutation,
} = authApi;
